import { UserUiStateKey } from "@models";
import * as contentful from "contentful";
import { ChatboxPosition, Crisp } from "crisp-sdk-web";
import { makeAutoObservable } from "mobx";
import React from "react";
import { RootStoreType } from ".";

type ActiveUiStateItem = UserUiStateKey | undefined;

export class UIStore {
  rootStore;
  _contentfulClient: contentful.ContentfulClientApi<undefined>;
  activeUiStateItem: ActiveUiStateItem; // Tooltip/Modal lock that only allows 1 tooltip or onboarding (uiUserState) to be shown at a time.
  mainRef: React.RefObject<HTMLDivElement> = React.createRef();

  isRightPanelOpen: boolean = false;
  isLeftPanelCollapsed: boolean = true;
  isChangelogModalOpen: boolean = false;
  lastSeenChangelogDate: string | null = null;
  constructor(rootStore: RootStoreType) {
    makeAutoObservable(this, { rootStore: false });
    this.rootStore = rootStore;

    this._contentfulClient = contentful.createClient({
      space: "vq9zrtptqmou",
      environment: "master", // defaults to 'master' if not set
      accessToken: "qAW1AmVqqdr3cdsCp3UWbpe1TEysmcDg_bBrOfuNGgs",
    });

    this.init();

    // load from local storage
    const isRightPanelOpen = localStorage.getItem("isRightPanelOpen");
    if (isRightPanelOpen) {
      this.isRightPanelOpen = isRightPanelOpen === "true";
    }

    const isLeftPanelCollapsed = localStorage.getItem("isLeftPanelCollapsed");
    if (isLeftPanelCollapsed) {
      this.isLeftPanelCollapsed = isLeftPanelCollapsed === "true";
    }

    const lastSeenChangelogDate = localStorage.getItem("lastSeenChangelogDate");
    if (lastSeenChangelogDate) {
      this.lastSeenChangelogDate = lastSeenChangelogDate;
    }
  }

  init() {
    Crisp.configure("51e809ec-3334-4cf4-82c1-7ffb48f6d2b5", {
      locale: "en",
      autoload: false,
    });
    Crisp.setPosition(ChatboxPosition.Right);
  }

  setActiveUiStateItem(tooltip: ActiveUiStateItem) {
    this.activeUiStateItem = tooltip;
  }

  setIsRightPanelOpen = (isOpen?: boolean) => {
    this.isRightPanelOpen = isOpen ?? !this.isRightPanelOpen;

    if (this.isRightPanelOpen) {
      this.isLeftPanelCollapsed = true;
      localStorage.setItem(
        "isLeftPanelCollapsed",
        this.isLeftPanelCollapsed.toString()
      );
    }

    // save to local storage
    localStorage.setItem("isRightPanelOpen", this.isRightPanelOpen.toString());
  };

  setIsLeftPanelCollapsed = (isCollapsed?: boolean) => {
    this.isLeftPanelCollapsed = isCollapsed ?? !this.isLeftPanelCollapsed;
    // save to local storage
    localStorage.setItem(
      "isLeftPanelCollapsed",
      this.isLeftPanelCollapsed.toString()
    );
  };

  setIsChangelogModalOpen = (isOpen: boolean) => {
    this.isChangelogModalOpen = isOpen;
  };

  markChangelogSeen = (date: string) => {
    this.lastSeenChangelogDate = date;
    localStorage.setItem("lastSeenChangelogDate", date);
  };
}
